import { Utils } from "@/plugins/utils";
import moment from "moment";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstFnl: [],
		fnl: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		totalCredit: 0,
		customerQuantity: 0,
		lstFiscalDocuments: [],
		loadingFiscalDocuments: false,
		itemsPerPageFD: 20,
		hasNextFD: false,
		fnlcliente: ""
	},
	getters: {
		fnlmodel(state){
			let fnl =  {...state.fnl}
			fnl.fnldatacre = Utils.ParseToDate(fnl.fnldatacre)
			fnl.fnldatacre = moment(fnl.fnldatacre).format("YYYY-MM-DDTHH:mm:ss");
			return fnl
		}
	},
	mutations: {
		set(state, fnl){
			state.fnl = fnl
			state.fnl.fnldatacre = new Date(fnl.fnldatacre).toLocaleDateString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			if (fnl)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.fnl = null
			state.lstFiscalDocuments = []
			state.loadingFiscalDocuments = false
			state.fnlcliente = ""
		},
		setParamsDataTable(state, payload){
			state.lstFnl = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setParamsDataTableFD(state, payload){
			state.lstFiscalDocuments = payload.items
			state.itemsPerPageFD = payload.limit
			state.hasNextFD = payload.hasNext
		},
		setTotals(state, totals){
			state.totalCredit = totals ? totals.totalCredit : 0
			state.customerQuantity = totals ? totals.customerQuantity : 0
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, { fnlemissor, fnltipo, fnlcliente, fnldoc }){
			return await this._vm.$axios.get(`/PurchaseCredit/PurchaseCredit/Find?fnlemissor=${fnlemissor}&fnltipo=${fnltipo}&fnldoc=${fnldoc}&fnlcliente=${fnlcliente}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, params){
			store.state.loading = true
			store.commit("initForm")

			await store.dispatch("get", params)
				.then(fnl => {
					if (fnl) { 
						store.commit("set", fnl)
					}
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				})

			store.state.loading = false
		},

		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/PurchaseCredit/PurchaseCredit/Insert", store.getters.fnlmodel )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/creditos")
				store.state.fnl = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/PurchaseCredit/PurchaseCredit/Update", store.getters.fnlmodel )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/creditos")
				store.state.fnl = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			
			if (!store.state.fnl) {
				return false;
			}

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/PurchaseCredit/PurchaseCredit/Delete/${store.state.fnl.fnlemissor}/${store.state.fnl.fnltipo}/${store.state.fnl.fnldoc}/${store.state.fnl.fnlcliente}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);		
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/PurchaseCredit/PurchaseCredit/FindList")
			.then(response => {
				let lstFnl = Utils.ValidateAxiosResponse(response.data);
				store.state.lstFnl = lstFnl
				store.state.hasNext = lstFnl.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstFnl = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC"}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/PurchaseCredit/PurchaseCredit/Search?search=${store.state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstFnl = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async calculateTotals(store){
			let payload = await this._vm.$axios.get("/PurchaseCredit/PurchaseCredit/CalculateTotals", { params: { search: store.state.search } })
			.then(response => {
				let totals = Utils.ValidateAxiosResponse(response.data);
				store.commit("setTotals", totals)
				return true
			})
			.catch((error) => {
				store.commit("setTotals", { totalCredit: 0, customerQuantity: 0 })
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			return payload
		},
		async findByCustomer(store, fnlcliente){
			return await this._vm.$axios.get(`/PurchaseCredit/PurchaseCredit/Find/${fnlcliente}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async findFiscalDocuments(store, { limit = 20, page = 1}){
			store.state.loadingFiscalDocuments = true
			await this._vm.$axios.get(`/PurchaseCredit/PurchaseCredit/FindFiscalDocuments/${store.state.fnlcliente}?limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTableFD", payload)
				return true
			})
			.catch((error) => {
				store.state.lstFiscalDocuments = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loadingFiscalDocuments = false
		},
	}
}
